/* Central date/time formatting — all timestamps in the app are UTC.
 *
 * Problem this solves (Jeremy's feedback): backend BSON datetimes serialize
 * WITHOUT a timezone suffix ("2026-07-09T14:21:22.390000"), which browsers
 * parse as LOCAL time → times displayed 2h early in Belgium. We therefore
 * treat suffix-less ISO strings as UTC and render in the workspace timezone
 * (default Europe/Brussels, configurable in Workspace Settings).
 */
let wsTimezone = "Europe/Brussels";

export function setWorkspaceTimezone(tz) {
    if (tz) wsTimezone = tz;
}

export function getWorkspaceTimezone() {
    return wsTimezone;
}

/** Parse an ISO string; suffix-less strings are interpreted as UTC. */
export function parseUTC(iso) {
    if (!iso) return null;
    if (iso instanceof Date) return iso;
    const hasTZ = /(Z|[+-]\d{2}:?\d{2})$/.test(iso);
    const d = new Date(hasTZ ? iso : `${iso}Z`);
    return isNaN(d.getTime()) ? null : d;
}

/** "09 jul, 16:24" (workspace timezone). */
export function fmtDateTime(iso, { year = false } = {}) {
    const d = parseUTC(iso);
    if (!d) return "";
    try {
        const date = d.toLocaleDateString(undefined, {
            day: "2-digit", month: "short", ...(year ? { year: "numeric" } : {}),
            timeZone: wsTimezone,
        });
        const time = d.toLocaleTimeString(undefined, {
            hour: "2-digit", minute: "2-digit", timeZone: wsTimezone,
        });
        return `${date}, ${time}`;
    } catch {
        return iso;
    }
}

/** "16:24" (workspace timezone). */
export function fmtTime(iso) {
    const d = parseUTC(iso);
    if (!d) return "";
    try {
        return d.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit", timeZone: wsTimezone });
    } catch { return iso; }
}

/** "09 jul 2026" (workspace timezone). */
export function fmtDate(iso) {
    const d = parseUTC(iso);
    if (!d) return "";
    try {
        return d.toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric", timeZone: wsTimezone });
    } catch { return iso; }
}

export const COMMON_TIMEZONES = [
    "Europe/Brussels", "Europe/Amsterdam", "Europe/Paris", "Europe/London",
    "Europe/Berlin", "Europe/Madrid", "UTC", "America/New_York",
];
